import { render, staticRenderFns } from "./AIChatPage.vue?vue&type=template&id=5e2ee640"
import script from "./AIChatPage.vue?vue&type=script&lang=js"
export * from "./AIChatPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports